import "./HeroImgStyles.css";
import React from 'react';
import IntroImg from '../assets/intro-bg.jpg';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

const HeroImg = () => {
  // Snappy Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { 
        staggerChildren: 0.1, 
        delayChildren: 0.1 
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1, 
      transition: { 
        type: "spring", 
        stiffness: 250, 
        damping: 20,
        mass: 0.5 
      } 
    }
  };

  return (
    <div className="hero">
      <motion.div 
        initial={{ scale: 1.1, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="mask"
      >
        <img className="intro-img" src={IntroImg} alt="Vasu Chopra Portfolio Background" />
      </motion.div>

      <motion.div 
        className="content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.p variants={itemVariants}>
          Hi, I am a Full Stack Developer
        </motion.p>
        
        <motion.h1 variants={itemVariants}>
          React Developer
        </motion.h1>
        
        <motion.div variants={itemVariants} className="button-group">
          <Link to="/project" className="btn">Projects</Link>
          <Link to="/contact" className="btn btn-light">Contact</Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default HeroImg;